module.exports = __webpack_public_path__ + "static/media/lite.605cd87c.jpg";